import { Injectable } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppConfigurationService } from './../../../cemexng2components/components/app-configuration';
import { payments } from '../../../rollout-containers';

@Injectable()
export class AdvancePaymentFormService {

    advancePaymentForm: FormGroup;
    locationForm: FormGroup;
    paymentMethodForm: FormGroup;
    customerControl: FormControl;
    companyControl: FormControl;
    jobsiteControl: FormControl;
    amountControl: FormControl;
    paymentMethodControl: FormControl;
    networkingControl: FormControl;
    networkingDetailControl: FormControl;
    salesOrderNumberControl: FormControl;
    
    amountMinAcceptance = 0; // borrar
    amountMaxAcceptance = 0; // borrar

    private featureService: AppConfigurationService;
    private requiredJobsite: boolean = false;
    public showSalesOrderNumber: boolean = false;

    constructor() {
        this.getFeatures();
        this.resetForm();
    }

    resetForm(): void {
        this.advancePaymentForm = new FormGroup({});
        this.locationForm = new FormGroup({});
        this.paymentMethodForm = new FormGroup({});

        this.customerControl = new FormControl(null, Validators.required);
        this.locationForm.addControl('customer', this.customerControl);

        this.companyControl = new FormControl(null, Validators.required);
        this.locationForm.addControl('company', this.companyControl);

        ///TODO: Move to observable///
        if (!this.requiredJobsite) {
            this.jobsiteControl = new FormControl(null, Validators.required);
        } else {
            this.jobsiteControl = new FormControl(null);
        }
        
        this.locationForm.addControl('jobsite', this.jobsiteControl);
        this.salesOrderNumberControl = new FormControl('', [Validators.maxLength(50), Validators.pattern(/^([a-zA-Z0-9]+)$/)]);
        this.locationForm.addControl('salesOrderNumber', this.salesOrderNumberControl);
        this.advancePaymentForm.addControl('location', this.locationForm);

        this.paymentMethodControl = new FormControl(null, Validators.required);
        this.paymentMethodForm.addControl('paymentMethod', this.paymentMethodControl);

        this.networkingControl = new FormControl(null, Validators.required);
        this.paymentMethodForm.addControl('networking', this.networkingControl);

        this.networkingDetailControl = new FormControl(null);
        this.paymentMethodForm.addControl('networkingDetail', this.networkingDetailControl);
        this.advancePaymentForm.addControl('paymentMethods', this.paymentMethodForm);

        this.amountControl = new FormControl(0, Validators.required);
        this.advancePaymentForm.addControl('amount', this.amountControl);
    }

    private getFeatures(): void {
        if (this.featureService){
            this.requiredJobsite = this.featureService.isEnabled('payments.v4.jobsite-required');
        }
    }

}
